import { ImageLoaderCSSStyleImpl } from 'src/com/sixdee/crbtportal/ui/toolkit/imageloader/imageloadercss';

export class ToneEvenCardImageLoaderCSSStyleImpl extends ImageLoaderCSSStyleImpl {
    getImgCSSStyle(): object {
        return {
            objectFit: 'cover',
            width: '100%',
            height: '250px',
            borderRadius: "0px 50px",
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/featuredcategory/viewmodel/tonecard/toneevencardimageloader.tsx